import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Card, Typography, Avatar,makeStyles  } from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import gradients from "../../../../utils/gradients";


const useStyles = makeStyles(theme => ({
  root: {
    color: props => props.isselected
        ?theme.palette.white : null ,
    backgroundColor: props => props.isselected
        ? theme.palette.primary.main
        : null,
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  avatar: {
    backgroundImage: gradients.green,
    height: 48,
    width: 48
  }
}));

const PaymentsSelect = props => {
  const { className, ...rest } = props;
  const classes = useStyles(props);


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      onClick={()=> {props.handleNavigatePages('payments')}}
    >
      <div>
        <Typography
          component="h3"
          gutterBottom
          variant="overline"
          color="inherit"
        >
          Payments
        </Typography>
        <div className={classes.details}>
          <Typography variant="h3" color="inherit">
            Received Payments
          </Typography>
        </div>
      </div>
      <Avatar className={classes.avatar}>
        <AttachMoneyIcon />
      </Avatar>
    </Card>
  );
};

PaymentsSelect.propTypes = {
  className: PropTypes.string
};

export default PaymentsSelect;
